import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { useDate } from 'utils/useDate'
import { useAuth0 } from '@auth0/auth0-react'
import { useTranslation } from 'react-i18next'

type ProposalStateEditProps = {
  bidderContactEmail: string
  proposalTS: Date
}

const ProposalStateEdit: React.FC<ProposalStateEditProps> = ({ bidderContactEmail, proposalTS }) => {
  const { formatDate } = useDate()
  const { loginWithRedirect } = useAuth0()
  const { t } = useTranslation()

  return (
    <Box sx={{ width: '100%', borderRadius: 1, backgroundColor: '#EFEFEF', p: 2, maxWidth: 443 }}>
      <header>
        <Typography paragraph>{t('request-for-proposal-has-already-been-answered')}</Typography>
      </header>
      <Typography variant="body2" paragraph color="textSecondary">
        {`${t('proposal-state-1')} ${formatDate(proposalTS, 'd.M.yyyy')}, ${t(
          'proposal-state-2'
        )} ${bidderContactEmail}. ${t('proposal-edit-state-3')}`}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button variant="contained" onClick={() => loginWithRedirect()}>
          {t('edit-proposal')}
        </Button>
      </Box>
    </Box>
  )
}

export default ProposalStateEdit
